// Inicializa GA4 una vez y envía un page_view en cada cambio de ruta de la SPA.
// Debe montarse DENTRO de <BrowserRouter> (usa useLocation).

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initGA, trackPageView } from '../lib/analytics';

const PageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    initGA();
  }, []);

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
};

export default PageTracking;
